// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"cngOvWAbmwcFyeB5z9af","divider":"e7HDT9ikAsuazjW7uTVM","container":"Vc5VAYcilP4W6ueYYDX6"};